import { IProductAddOptions } from "@faire/deprecated-retailer-visitor-shared/features/ProductAdd/ProductAddOptions";
import { UpdateCartHandler } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/consts";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { lazy } from "react";

export interface IQuickAddModalProps {
  productToken: string;
  onClose: () => void;
  onChooseOptionQuantityUpdate?: (newQuantity?: number) => void;
  fetchedProductOverride?: IProduct;
  productAddOptionsForBrandInvoice?: IProductAddOptions;
  // TODO: Pass in updateCart handler instead of passing in prdouctAddOptions
  updateCartFn?: UpdateCartHandler;
}

export const LazyQuickAddModal = lazy(() =>
  import(
    /* webpackChunkName: "retailer-quick-add-modal" */ "@faire/deprecated-retailer-visitor-shared/features/ProductQuickAddModal/QuickAddModal"
  ).then((m) => ({ default: m.QuickAddModal }))
);
